<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  computed: {},
  created() {
    this.getColumnList();
  },
  mounted() {},
  methods: {
    getColumnList() {
      this.$axios.get(this.urls.columnList).then((res) => {
        let list = res.data.result;
        if (list) {
          this.$store.commit("setColumnData", list);
        }
      });
    },
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
}
div.el-input-group__append {
  width: 48px !important;
  padding: 0 !important;
}
.search-btn {
  height: 36px;
  text-align: center;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue